import { Injectable, inject, isDevMode } from '@angular/core';
import { Title } from '@angular/platform-browser';
import type { RouterStateSnapshot } from '@angular/router';
import { TitleStrategy } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { capitalize } from 'lodash';
import { environment } from '../../../config/environment';

@Injectable()
export class AppTitleStrategy extends TitleStrategy {
  private readonly title = inject(Title);
  private readonly translateService = inject(TranslateService);

  private readonly SUFFIX = isDevMode()
    ? `ONYX · ${capitalize(environment.type)}${location.hostname.includes('localhost') ? ' (localhost)' : ''}`
    : 'ONYX';

  public override updateTitle(snapshot: RouterStateSnapshot): void {
    const [module, page] = snapshot.url
      .split(/[?#(]/)[0]
      .split('/')
      .filter(Boolean);
    const keys = [
      `navSubmenu.routes./${module}/${page}`,
      `dashboard.navBar.routes./${module}`,
    ];

    this.translateService
      .get(keys)
      .subscribe((labels: Record<string, string>) => {
        const label = keys
          .map((key) => labels[key])
          .find((text, i) => text !== keys[i]);
        this.title.setTitle(label ? `${label} · ${this.SUFFIX}` : this.SUFFIX);
      });
  }
}
